"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VelocityCredentialTypes = exports.EvidenceTypes = exports.DetailDurationType = exports.DetailLevel = exports.DetailDuration = exports.DetailCost = exports.DetailType = void 0;
const DetailEnums_json_1 = require("./DetailEnums.json");
const detailType = DetailEnums_json_1.DetailType;
exports.DetailType = detailType;
const detailCost = DetailEnums_json_1.DetailCost;
exports.DetailCost = detailCost;
const detailDuration = DetailEnums_json_1.DetailDuration;
exports.DetailDuration = detailDuration;
const detailLevel = DetailEnums_json_1.DetailLevel;
exports.DetailLevel = detailLevel;
const detailDurationType = DetailEnums_json_1.DetailDurationType;
exports.DetailDurationType = detailDurationType;
const evidenceTypes = DetailEnums_json_1.EvidenceTypes;
exports.EvidenceTypes = evidenceTypes;
const velocityCredentialTypes = DetailEnums_json_1.VelocityCredentialTypes;
exports.VelocityCredentialTypes = velocityCredentialTypes;
